import _every from "lodash/every";
import _filter from "lodash/filter";
import _flatMap from "lodash/flatMap";
import _includes from "lodash/includes";
import _isEmpty from "lodash/isEmpty";
import _map from "lodash/map";
import { TFunction } from "i18n";
import { IFacetResponse } from "shared-types/src/Facets";
import { formatListWithMore } from "pages/JobsPage/components/RolePreferences/helpers/formatListWithMore";

interface MapContractTypesProps {
  facet?: IFacetResponse;
  facetIds: number[];
  anyContractType?: boolean;
  t: TFunction;
}

export function mapContractTypes({
  facet,
  facetIds,
  anyContractType,
  t,
}: MapContractTypesProps): string {
  if (anyContractType) {
    return t("common:jobs.page.rolePreferences.contractTypes.anyDescription");
  }

  if (!facet || _isEmpty(facet.facetGroups) || _isEmpty(facetIds)) {
    return "";
  }

  return formatListWithMore(
    _flatMap(facet.facetGroups, (facetGroup) => {
      const groupFacetIds = _map(facetGroup.facets, ({ id }) => id);
      const isAllGroupFacetsSelected =
        !_isEmpty(groupFacetIds) &&
        _every(groupFacetIds, (facetId) => _includes(facetIds, facetId));

      if (isAllGroupFacetsSelected) {
        return [facetGroup.name];
      }

      return _map(
        _filter(facetGroup.facets, ({ id }) => _includes(facetIds, id)),
        "name"
      );
    }),
    t
  );
}
